export const MAX_VISIBLE_FILTERS = 7;
export const COMMON_FILTERS = [
  '_type',
  'for_day',
  'dates',
  'region',
  'geo',
  'engine_version',
  'price',
  'roomType',
  'onlineBooking',
  'kidsAllowed',
  'petsAllowed',
  'fromHomeowner',
  'noDeposit',
  'beds_count',
  'page',
];

// Поля, которые не сбрасываются при сбросе всех фильтров
export const NON_RESETTABLE_FILTERS = ['_type', 'for_day', 'dates', 'region', 'engine_version', 'geo', 'beds_count'];
